@if((this.userId == 0 || this.userId == this.authService.currentUserIds || this.userId == null) && (!isModeEdition || customerOnlyUnlock) && !quoteContentReadOnly){
<!-- class mobile solo para verificar en el navegador el cambio -->
<div id="clientMobile">
  <div class="title">
    <h3>Cliente</h3>
    <label class="checkboxWrapper" for="conRFC">
      <input type="checkbox" id="conRFC" [checked]="isClientWithRFC()" (change)="onCheckboxChange($event)" />
      <span class="checkmark"></span>
      <span class="description">Con RFC</span>
    </label>
    <div class="acciones">
      @if(isClientWithRFC() && formHasRFC){
      <a tp="Seleccionar otro cliente" class="refresh" (click)="openModalSelectClient()">Seleccionar otro cliente</a>
      }
      @if(isEditable){
      <a class="edit" tp="Editar cliente" (click)="openEditClient()">Editar</a>
      }
    </div>
  </div>
  <form [formGroup]="formCustomer">
    @if(!isClientWithRFC()){
      <div>
        <div class="wrapper">
          <div class="controlWrapper">
            <label for="">Tipo de cliente <span class="required">*</span></label>
            <div class="customSelect">
              <select
                type="text"
                formControlName="customerType"
                id="customerType"
                (keypress)="allowAlphabeticCharacter($event)"
                tabindex="7"
              >
                <option [value]="'CV_FLEET'">CV Fleets</option>
                <option [value]="'CV_SMALL_BUSINESS'">CV Small Business</option>
                <option [value]="'DEALER'">Dealer</option>
              </select>
            </div>
          </div>
          <div class="controlWrapper calificacion">
            <label for="classificationDtsm"
              >Calificación DTFSM <span class="required">*</span></label
            >
            <input
              name=""
              type="number"
              id="classificationDtsm"
              formControlName="dfsRating"
              (blur)="validateDfsRating()"
              tabindex="8"
            />
            <div
              class="error"
              *ngIf="
                formCustomer.get('dfsRating')?.hasError('required') &&
                formCustomer.get('dfsRating')?.touched
              "
            >
              El número es requerido.
            </div>
            <div
              class="error"
              *ngIf="formCustomer.get('dfsRating')?.hasError('pattern')"
            >
              El número debe estar entre 1 y 10.
            </div>
          </div>
          <div class="controlWrapper">
            <label for="">Tipo de persona <span class="required">*</span></label>
            <div class="customSelect">
              <select
                type="text"
                formControlName="personType"
                (ngModelChange)="validatorChange()"
                (keypress)="allowAlphabeticCharacter($event)"
                tabindex="9"
              >
                <option [value]="'NATURAL_PERSON'" selected (blur)="onEdit()">
                  Persona física
                </option>
                <option [value]="'LEGAL_PERSON'" selected (blur)="onEdit()">
                  Persona moral
                </option>
              </select>
            </div>
            <div
              *ngIf="
                formCustomer.get('personType')?.hasError('required') &&
                formCustomer.get('personType')?.touched
              "
            >
              El campo es requerido.
            </div>
          </div>
        </div>
        <div class="wrapperG4">
          <div
            class="controlWrapper"
            *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            "
          >
            <label for="paternalSurname"
              >Apellido paterno <span class="required">*</span></label
            >
            <input
              name=""
              type="text"
              id="paternalSurname"
              formControlName="lastName"
              (blur)="onEdit()"
              tabindex="10"
            />
          </div>
          <div
            class="controlWrapper"
            *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            "
          >
            <label for="maternalSurname"
              >Apellido materno</label
            >
            <input
              name=""
              type="text"
              id="maternalSurname"
              formControlName="mothersLastName"
              (blur)="onEdit()"
              tabindex="11"
            />
          </div>
          <div class="controlWrapper">
            <label for="customerName">Nombre <span class="required">*</span></label>
            <input
              *ngIf="
                this.formCustomer.controls['personType'].value == 'NATURAL_PERSON';
                else JuridicalPerson
              "
              name="customerName"
              type="text"
              id="customerName"
              formControlName="name"
              (blur)="onEdit()"
              tabindex="12"
            />
            <ng-template #JuridicalPerson>
              <input
                name="customerName"
                type="text"
                id="customerName"
                formControlName="name"
                (blur)="onEdit()"
                tabindex="12"
              />
            </ng-template>
          </div>
          <div
            class="controlWrapper"
            *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            "
          >
            <label for="secondName">Segundo nombre</label>
            <input
              name=""
              type="text"
              id="secondName"
              formControlName="secondName"
              (blur)="onEdit()"
              tabindex="13"
            />
          </div>
        </div>
      </div>
    } @else {
      <!-- Form para clientes sin RFC -->
      <div>
        <div class="wrapperG4 withRfc">
          <div class="controlWrapper">
            <label for="">Tipo de cliente <span class="required">*</span></label>
            <div class="customSelect">
              <select type="text" formControlName="customerType" id="customerType"
                (keypress)="allowAlphabeticCharacter($event)">
                <option [value]="'CV_FLEET'">CV Fleets</option>
                <option [value]="'CV_SMALL_BUSINESS'">CV Small Business</option>
                <option [value]="'DEALER'">Dealer</option>
              </select>
            </div>
          </div>
          <div class="controlWrapper calificacion">
            <label for="classificationDtsm">Calificación DTFSM <span class="required">*</span></label>
            <input name="" type="number" id="classificationDtsm" formControlName="dfsRating"
              (blur)="validateDfsRating()" />
            <div class="error"
              *ngIf="formCustomer.get('dfsRating')?.hasError('required') && formCustomer.get('dfsRating')?.touched">
              El número es requerido.
            </div>
            <div class="error" *ngIf="formCustomer.get('dfsRating')?.hasError('pattern')">
              El número debe estar entre 1 y 10.
            </div>
          </div>

          <!-- Mostrar si el cliente está seleccionado -->
          @if(personType){
          <div class="controlWrapper">
            <label>Tipo de persona</label>
            <span class="value">{{ clientsService.getPersonType(personType) }}</span>
          </div>
          }
          @if(rfc){
          <div class="controlWrapper">
            <label>RFC</label>
            <span class="value">{{ rfc }}</span>
          </div>
          }
          @if(!isLegalPerson()) {
            @if(lastName){
              <div class="controlWrapper">
                <label>Apellido paterno</label>
                <span class="value">{{ lastName }}</span>
              </div>
            }
            @if(mothersLastName){
              <div class="controlWrapper">
                <label>Apellido materno</label>
                <span class="value">{{ mothersLastName }}</span>
              </div>
            }
          }
        @if(name){
          <div class="controlWrapper" [ngClass]="{ moral: isLegalPerson() }">
            <label>Nombre</label>
            <span class="value">{{ name }}</span>
          </div>
        }
        </div>
        <!-- Mostrar sin no hay ningun cliente seleccionado -->
        @if(!formHasRFC){
        <div class="actions withRfc">
          <button class="tertiary" (click)="openModalSelectClient()" tabindex="9">Seleccionar cliente</button>
        </div>
        }
      </div>
      }

    @if (featureLoyaltyFeriaQuotation) {
    <div class="loyaltyFeriaFlags" aria-label="Programas cliente">
      <label class="checkboxWrapper" for="openFeriaMob">
          <input
            type="checkbox"
            id="openFeriaMob"
            [ngModel]="formCustomer.get('feriaCustomer')?.value"
            (ngModelChange)="formCustomer.get('feriaCustomer')?.setValue($event)"
          />
        <span class="checkmark"></span>
        <span class="description">Feria</span>
      </label>
    </div>
    }

  </form>
</div>
} @if(((((this.userId != this.authService.currentUserIds && this.userId > 0) || isModeEdition)) && !customerOnlyUnlock) || quoteContentReadOnly){
<!-- Versión sólo lectura -->
<div id="clientMobile" class="readOnly">
  <h3>Cliente</h3>
  <div class="wrapper">
    <div class="tipoYClasificacion">
      <div>
        <label>Tipo de cliente</label>
        <span class="value">{{ financialCalculator.getTypeClient(formCustomer.controls['customerType'].value) }}</span>
      </div>
      <div>
        <label>Calificación DTFSM</label>
        <span class="value">{{ formCustomer.controls['dfsRating'].value }}</span>
      </div>
    </div>

    <div>
      <label>Tipo de persona</label>
      <span class="value">{{ financialCalculator.getPersonType(formCustomer.controls['personType'].value) }}</span>
    </div>

    @if(rfc){
      <div>
        <label>RFC</label>
        <span class="value">{{ rfc }}</span>
      </div>
    }

    @if(lastName){
      <div>
        <label>Apellido paterno</label>
        <span class="value">{{ lastName }}</span>
      </div>
    }

    @if(mothersLastName){
      <div *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
        <label>Apellido materno</label>
        <span class="value">{{ mothersLastName }}</span>
      </div>
    }

    @if(name){
    <div>
      <label>Nombre</label>
      <span class="value">{{ name }}</span>
    </div>
    }

    @if(secondName){
      <div *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
        <label>Segundo nombre</label>
        <span class="value">{{ secondName }}</span>
      </div>
    }

    @if (featureLoyaltyFeriaQuotation) {
      <div>
        <label>Cliente de feria</label>
        <span class="value">{{ customerFeriaReadonlyYesNo() }}</span>
      </div>
    }
  </div>
</div>
}

<ng-template #modalSelectClient>
  <app-client-select-modal-mobile
    style="width: 100%"
    (openNewClient)="openModalNewClient()"
    (selectedClient)="selectExistingClient($event)"
  />
</ng-template>
<ng-template #modalNewClient>
  <app-client-form-modal-mobile (savedClient)="saveAndUpdateClientForm($event)"  [client]="selectedClient()" (cancelModalE)="cancelModal($event)" />
</ng-template>
